// const formatAddress = (address) => {
//   return address.split(",").map((part, i) => (
//     <span key={i}>
//       {part.trim()}
//       {i < address.split(",").length - 1 && <span>, </span>}
//       <wbr />
//     </span>
//   ));
// };

// export default formatAddress;

const formatAddress = (address = "") => {
  const parts = address.split(",").map((p) => p.trim());

  return parts.map((part, i) => {
    const isLast = i === parts.length - 1;

    return (
      <span key={i}>
        {!isLast ? (
          <>
            {part}, <wbr />
          </>
        ) : (
          // postcode: never break
          <span className="addr-postcode" style={{ whiteSpace: "nowrap" }}>
            {part}
          </span>
        )}
      </span>
    );
  });
};

export default formatAddress;
